export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["shift"] = 16] = "shift";
})(KeyCode || (KeyCode = {}));
export function isNodeOrCollection(someObject) {
    return (someObject instanceof Node ||
        someObject instanceof NodeList ||
        Array.isArray(someObject) ||
        someObject instanceof HTMLCollection);
}
export function addClass(element, className) {
    if (typeof element.classList !== 'undefined') {
        className.split(' ').forEach(function (cls) {
            if (cls.trim()) {
                element.classList.add(cls);
            }
        });
    }
    else {
        if (!hasClass(element, className)) {
            var cls = (element.className || '') + (' ' + className);
            setClass(element, cls);
        }
    }
}
export function removeClass(element, className) {
    if (typeof element.classList !== 'undefined') {
        className.split(' ').forEach(function (cls) {
            if (cls.trim()) {
                element.classList.remove(cls);
            }
        });
    }
    else {
        var regex = new RegExp('(^| )' + className.split(' ').join('|') + '( |$)', 'gi');
        var cls = element.className.replace(regex, ' ');
        setClass(element, cls);
    }
}
export function hasClass(element, className) {
    if (typeof element.classList !== 'undefined') {
        return element.classList.contains(className);
    }
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
}
export function setClass(element, className) {
    element.setAttribute('class', className);
}
export function findUpUntil(node, callback) {
    while (node && !callback(node)) {
        node = node.parentElement;
    }
    return node;
}
// Based on Jquery UI utility function
// https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
export function getScrollParent(node) {
    var overflowRegex = /(auto|scroll)/;
    return findUpUntil(node.parentElement, function (element) { return overflowRegex.test(getComputedStyle(element).overflow); });
}
/**
 * Returns an element that is used to position the given element.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
 */
export function getContainingBlock(startElement) {
    return supportsContainingBlockPositioning()
        ? findUpUntil(startElement.parentElement, function (element) {
            var style = getComputedStyle(element);
            // getComputedStyle used to sometimes return `null` in FireFox https://bugzilla.mozilla.org/show_bug.cgi?id=1467722
            return (style &&
                ((style.transform && style.transform !== 'none') || (style.perspective && style.perspective !== 'none')));
        })
        : null;
}
var _supportsContainingBlockPositioning = undefined;
/**
 * Returns whether `position: fixed` can be relative to transformed parents or whether it's always relative to
 * the viewport. Returns `true` on all browsers except IE.
 */
function supportsContainingBlockPositioning() {
    if (_supportsContainingBlockPositioning !== undefined) {
        return _supportsContainingBlockPositioning;
    }
    var parent = document.createElement('div');
    parent.style.transform = 'translateY(5px)';
    document.body.appendChild(parent);
    var child = document.createElement('div');
    child.style.position = 'fixed';
    child.style.top = '0';
    parent.appendChild(child);
    _supportsContainingBlockPositioning = parent.getBoundingClientRect().top === child.getBoundingClientRect().top;
    document.body.removeChild(parent);
    return _supportsContainingBlockPositioning;
}
// Technique borrowed from Bootstrap: Create an offscreen div styled to ensure a scrollbar exists,
// then measure its dimensions to get scrollbar width.
// https://github.com/twbs/bootstrap/blob/master/js/modal.js#L277
export function browserScrollbarSize() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.height = '100px';
    scrollDiv.style.width = '100px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.left = '-9999px';
    document.body.appendChild(scrollDiv);
    var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    var height = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    return { width: width, height: height };
}
//# sourceMappingURL=dom.js.map